export const USER_AUTH_TICKET = 'USER_AUTH_TICKET';
export const USER_LEGACY_TOKEN = 'USER_LEGACY_TOKEN';

export interface AuthState {
  legacyToken?: string;
  loggedIn: boolean;
  token: string;
}

interface AuthTicketAction {
  type: typeof USER_AUTH_TICKET;
  token: string;
}

interface LegacyAuthTokenAction {
  type: typeof USER_LEGACY_TOKEN;
  token: string;
}

export type AuthActions = AuthTicketAction | LegacyAuthTokenAction;
